export default __webpack_public_path__ + "static/media/site-preview.58738f3b.png";